const decText = [
  "many BROs is better than ONDER",
  "decentralize BRONDER, claim your piece of the pie",
  "BRONDER DAO soonTM",
  "community owned, BRONDER",
  "you are the BRONDER, goo goo goo joob",
];

const randomNumber = Math.floor(Math.random() * decText.length);
const decentralBro = decText[randomNumber];

export { decentralBro };
